// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ADIh","footer":"ChangeClinic_footer__1k5Fc"};